<script>
  import { Router, Route } from "svelte-routing";

  import Index from "./routes/Index.svelte";
  import Alberto from "./routes/Alberto.svelte";
  
  export let url = "";

  function logSomething(something) {
    console.log(something);
  }

  logSomething('logging works');


</script>

<Router {url}>
  <div>
    <Route path="/"><Index /></Route>
    <Route path="/alberto"><Alberto /></Route>
  </div>
</Router>
